import { Permissao } from './../../../_core/models/permissao';
import { Usuario } from 'src/app/_core/models/usuario';
import { PermissaoService } from './../../../_core/services/permissao.service';
import { Subject } from 'rxjs';

import { UploadService } from './../../../_core/services/upload.service';
import { Localizacao } from './../../../_core/models/localizacao';
import { LocalizacaoService } from './../../../_core/services/localizacao.service';
import { formatDate, DOCUMENT, DatePipe } from '@angular/common';
import { TipoDeBemService } from '../../../_core/services/tipo-de-bem.service';
import { TipoDeBem } from 'src/app/_core/models/tipo-de-bem';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CadastroBemService } from '../../../_core/services/cadastro-bem.service';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  ChangeDetectorRef,
  ElementRef,
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CadastroBem } from 'src/app/_core/models/cadastro-bem';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { HttpEventType, HttpRequest, HttpClient } from '@angular/common/http';
import { Arquivo } from 'src/app/_core/models/arquivo';
import {
  FileSelectDirective,
  FileDropDirective,
  FileUploader,
} from 'ng2-file-upload';
import { environment as env } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { LoginService } from 'src/app/_core/services/login.service';
@Component({
  selector: 'app-cadastro-bens-modal',
  templateUrl: './cadastro-bens-modal.component.html',
  styleUrls: ['./cadastro-bens-modal.component.scss'],
})
export class CadastroBensModalComponent implements OnInit {
  @Input() public nR_BPM_BEM_PATRIMONIAL: number;
  @ViewChild('file') file: any;
  title = 'Formulário de bens';
  cadastro: CadastroBem;
  public data: Usuario[];
  cadastroBens!: CadastroBem[];
  form!: FormGroup;
  error!: string;
  public tipoDeBem!: TipoDeBem[];
  keyword = 'dS_BPM_UNIDADE';
  public keywordTipo = 'dS_BPM_DESCRICAO_TIPO_BEM';
  public localizacao!: Localizacao[];
  loading = true;
  public progress!: number;
  uploader!: FileUploader;
  message!: string;
  arquivo!: Arquivo;
  arquivos: Arquivo[] = [];
  dataNota: Date;
  user: Usuario;
  permissao: Permissao[];
  userPerm = true;
  listarNomes = true;
  term: string;
  id: any;
  dataAtual: any;
  keywordMatriculaDest = 'nome';

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    public datePipe: DatePipe,
    public modalService: NgbModal,
    private route: ActivatedRoute,
    private cadastroBemService: CadastroBemService,
    private tipoDeBemService: TipoDeBemService,
    private localizacaoService: LocalizacaoService,
    private http: HttpClient,
    private loginService: LoginService,
    private router: Router,
    private uploadService: UploadService,
    private permissaoService: PermissaoService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.arquivo = new Arquivo();
    this.OnFileUpload();
    this.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    //console.log/this.user);
    this.getAcessoPermissao();
  }

  ngOnInit() {
    //console.log/this.nR_BPM_BEM_PATRIMONIAL);
    this.cadastro = new CadastroBem();
    this.gerarForm(this.cadastro);
    this.listarUser();
    this.listarBensById();
    this.uploadGetById();
    this.listarLocalizacaoBensAll();
    this.OnFileUpload();
    this.loading = false;
    this.listarTipoDeBensAll();
    const dt = new Date();
    this.dataAtual = dt.getFullYear()+'-'+("00" + (dt.getMonth()+1)).slice(-2)+'-'+("00" + dt.getDate()).slice(-2);
  }
  refresh() {
    this.document.location.reload();
  }
  // markAsRead() {
  //   this.form.get('cD_BPM_NR_UNIDADE')?.markAsTouched();
  // }

  listarUser() {
    setTimeout(() => {
      this.loginService.getCADUInsertBem()
        .pipe().subscribe(
          data => {
            this.data = data;
            this.data.map(data => data.nome = ` ${data.cD_MATRICULA} | ${data.nome} `)
          }
        )
    }, 300)



  }

  selectEvent(item: any) {
    const num = item.cD_BPM_NR_UNIDADE;
    this.form.get('cD_BPM_NR_UNIDADE')?.setValue(num);
  }
  selectTipo(item: any) {
    //console.log/item.nR_BPM_TIPO_BEM_PATRIMONIAL);
    const num = item.nR_BPM_TIPO_BEM_PATRIMONIAL;
    this.form.get('nR_BPM_TIPO_BEM_PATRIMONIAL')?.setValue(num);
  }

  selectDest(item: any) {
    const num = item.cD_MATRICULA
    this.form.get('cD_CDU_MATRICULA_USUARIO_CAUTELA')?.setValue(num)
  }

  clearInputDest() {
    this.form.controls['cD_CDU_MATRICULA_USUARIO_CAUTELA'].setValue(null);
  }

  onChangeSearch(search: string) {
    //console.log/search);
  }

  onFocused(e: any) {}
  getAcessoPermissao() {
    //console.log/this.user.cD_MATRICULA);
    this.permissaoService
      .getBy_SiglaMatricula('PATRIMONIO', this.user.cD_MATRICULA)
      .subscribe((data) => {
        //console.log/'PERMISSÃO ', data);
        this.permissao = data;
        let index = this.permissao.map(function (e) {
          return e.DS_PERFIL_ACESSO.indexOf('contabilidade');
        });
        //console.log/'Cargo ' + index);
        if (index[0] == 0) {
          this.userPerm = false;
          this.form
            .get('nR_BPM_IMOBILIZADO_TI')
            ?.setValidators(Validators.required);
          return this.form
            .get('nR_BPM_IMOBILIZADO_TI')
            ?.updateValueAndValidity();
        } else {
          this.form.get('nR_BPM_IMOBILIZADO_TI')?.clearValidators();
          this.form.get('nR_BPM_IMOBILIZADO_TI')?.updateValueAndValidity();
        }
      });
  }
  OnFileUpload() {
    this.uploader = new FileUploader({
      url: env.baseurl + '/Arquivo/upload',
      method: 'POST',
      disableMultipart: true,
      allowedMimeType: ['image/gif', 'image/jpeg', 'image/png'],
      formatDataFunctionIsAsync: true,
      isHTML5: true,
      removeAfterUpload: false,
      autoUpload: false,
      maxFileSize: 10 * 1024 * 1024,
    });
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
  }
  clearFile() {
    this.file.nativeElement.value = '';
  }
  removeFile(item: any) {
    //console.log/item);
    let remov: any = this.arquivos.splice(item, 1);
    this.clearFile();
    this.uploader.removeFromQueue(item);
    // //console.log/"ARQUIVOS => ", remov)
    localStorage.setItem('arquivos', JSON.stringify(this.arquivos));
  }
  remover(cD_BPM_ARQUIVO_PATRIMONIAL: number, indexOfelement: number) {
    this.loading = true;
    let remov: any = this.arquivos.splice(indexOfelement, 1);
    //console.log/'ARQUIVOS => ', remov);
    this.uploadService
      .delete(this.nR_BPM_BEM_PATRIMONIAL, cD_BPM_ARQUIVO_PATRIMONIAL)
      .subscribe(
        (data) => {
          Swal.fire(
            'Deletado!',
            'Arquivo deletado com sucesso!',
            'success'
          ).then(() => {
            this.arquivos.splice(indexOfelement, 1);

            localStorage.setItem('arquivos', JSON.stringify(remov));
            //console.log/'ARQUIVOS => ', localStorage.getItem('arquivos'));
            this.loading = false;
            this.ngOnInit();
          });
        },
        (err) => {
          //console.log/'Erro:  ', JSON.stringify(err));
        }
      );
  }
  upload(files: any) {
    //console.log/files);
    if (files.length === 0) return;

    const formData = new FormData();

    formData.append('file', files[0]);

    const uploadReq = new HttpRequest(
      'POST',
      env.baseurl + '/Arquivo/upload',
      formData,
      {
        reportProgress: true,
      }
    );

    this.http.request(uploadReq).subscribe((event: any) => {
      if (event.type === HttpEventType.UploadProgress) {
        this.progress = Math.round((100 * event.loaded) / event.total);
      } else if (event.type === HttpEventType.Response) {
        this.message = 'Baixado com sucesso.';
        this.arquivo = event.body;
        this.arquivo.cD_BPM_ARQUIVO_PATRIMONIAL = this.arquivos.push(
          this.arquivo
        );
        localStorage.setItem('arquivos', JSON.stringify(this.arquivos));
        this.arquivo = new Arquivo();
      }
    });
  }
  uploadGetById() {
    if (this.nR_BPM_BEM_PATRIMONIAL != 0) {
      this.uploadService
        .upload_getById(this.nR_BPM_BEM_PATRIMONIAL)
        .subscribe((data) => {
          this.arquivos = data;
          this.form.get('arquivos')?.setValue(this.arquivos);
          //console.log/this.arquivos);
        });
    }
  }

  listarBensById() {
    if (this.nR_BPM_BEM_PATRIMONIAL != 0) {
      this.cadastroBemService
        .listarBensById(this.nR_BPM_BEM_PATRIMONIAL)
        .subscribe((data) => {
          this.cadastro = data;
          this.gerarForm(this.cadastro);
        });
    }
  }
  gerarForm(cadastro: CadastroBem) {
    this.form = this.fb.group({
      cD_BPM_NR_UNIDADE: [cadastro?.cD_BPM_NR_UNIDADE, [Validators.required]],
      dS_BPM_ETIQUETA_BEM: [cadastro?.dS_BPM_ETIQUETA_BEM],
      dS_BPM_DESCRICAO_BEM: [
        cadastro?.dS_BPM_DESCRICAO_BEM,
        [Validators.required],
      ],
      nR_BPM_IMOBILIZADO_TI: [
        cadastro?.nR_BPM_IMOBILIZADO_TI,
        [Validators.required],
      ],
      nR_BPM_TIPO_BEM_PATRIMONIAL: [
        cadastro?.nR_BPM_TIPO_BEM_PATRIMONIAL,
        [Validators.required],
      ],
      cD_CDU_MATRICULA_USUARIO_CAUTELA: [
        cadastro?.cD_CDU_MATRICULA_USUARIO_CAUTELA,
        [Validators.required],
      ],
      vL_BPM_VALOR_AQUISICAO: [cadastro?.vL_BPM_VALOR_AQUISICAO, []],
      dS_BPM_NUMERO_SERIE: [cadastro?.dS_BPM_NUMERO_SERIE, []],
      dS_BPM_OUTROS: [cadastro?.dS_BPM_OUTROS, []],
      dS_BPM_MARCA: [cadastro?.dS_BPM_MARCA, []],
      dS_BPM_MODELO: [cadastro?.dS_BPM_MODELO, []],
      dS_BPM_PLACA: [cadastro?.dS_BPM_PLACA, []],
      nR_BPM_NUMERO_CONTRATO: [
        cadastro?.nR_BPM_NUMERO_CONTRATO,
        [Validators.required],
      ],
      dT_BPM_DATA_NOTA_FISCAL: [
        this.datePipe.transform(cadastro?.dT_BPM_DATA_NOTA_FISCAL, 'yyyy-MM-dd'),
        [Validators.required],
      ],
      nR_BPM_NUMERO_NOTA_FISCAL: [
        cadastro?.nR_BPM_NUMERO_NOTA_FISCAL,
        [Validators.required],
      ],
      dS_BPM_SALA: [cadastro?.dS_BPM_SALA, []],
      fL_BPM_ATIVO: [cadastro?.fL_BPM_ATIVO, []],
      fL_BPM_DELETADO: [0],
      arquivos: [cadastro?.arquivos, []],
      cD_CDU_MATRICULA_AUTOR: [this?.user.cD_MATRICULA, []],
    });
  }
  esconderLista() {
    this.listarNomes = false;
  }

  mostrarLista() {
    this.listarNomes = true;
  }

  listarItens() {
    this.loading = true;
  }
  listarTipoDeBensAll() {
    this.tipoDeBemService.listarTipoDeBensAll().subscribe((data) => {
      this.tipoDeBem = data;
    });
  }
  listarLocalizacaoBensAll() {
    this.localizacaoService.localizacaoAll().subscribe((data) => {
      this.localizacao = data;
    });
  }
  submit() {
    //console.log/'Cargo obrigatorio', this.form?.value);
    if (this.form.invalid) {
      //console.log/"retorno");
      //console.log/this.form.invalid);
      //console.log/this.form.get('cD_BPM_NR_UNIDADE'))
      var retorno = '';
      if(this.form.controls['cD_BPM_NR_UNIDADE'].value == null) {
        retorno+= 'Número da Unidade ';
        this.form.controls['cD_BPM_NR_UNIDADE'].setErrors({'required': true});
        this.form.controls['cD_BPM_NR_UNIDADE'].markAsTouched();
      }
      if(this.form.controls['dS_BPM_DESCRICAO_BEM'].value == null) {
        retorno != '' ? retorno+= ', Descrição' : retorno+= 'Descrição';
        this.form.controls['dS_BPM_DESCRICAO_BEM'].setErrors({'required': true});
        this.form.controls['dS_BPM_DESCRICAO_BEM'].markAsTouched();
      }
      if(this.form.controls['nR_BPM_IMOBILIZADO_TI'].value == null) {
        retorno != '' ? retorno+= ', Número do Imobilizado' : retorno+= 'Número do Imobilizado';
        this.form.controls['nR_BPM_IMOBILIZADO_TI'].setErrors({'required': true});
        this.form.controls['nR_BPM_IMOBILIZADO_TI'].markAsTouched();
      }
      if(this.form.controls['nR_BPM_TIPO_BEM_PATRIMONIAL'].value == null) {
        retorno != '' ? retorno+= ', Tipo do Bem' : retorno+= 'Tipo do Bem';
        this.form.controls['nR_BPM_TIPO_BEM_PATRIMONIAL'].setErrors({'required': true});
        this.form.controls['nR_BPM_TIPO_BEM_PATRIMONIAL'].markAsTouched();
      }
      if(this.form.controls['nR_BPM_NUMERO_CONTRATO'].value == null) {
        retorno != '' ? retorno+= ', Número do Contrato' : retorno+= 'Número do Contrato';
        this.form.controls['nR_BPM_NUMERO_CONTRATO'].setErrors({'required': true});
        this.form.controls['nR_BPM_NUMERO_CONTRATO'].markAsTouched();
      }
      if(this.form.controls['dT_BPM_DATA_NOTA_FISCAL'].value == null) {
        retorno != '' ? retorno+= ', Data da Nota Fiscal' : retorno+= 'Data da Nota Fiscal';
        this.form.controls['dT_BPM_DATA_NOTA_FISCAL'].setErrors({'required': true});
        this.form.controls['dT_BPM_DATA_NOTA_FISCAL'].markAsTouched();
      }
      if(this.form.controls['nR_BPM_NUMERO_NOTA_FISCAL'].value == null) {
        retorno != '' ? retorno+= ', Número da Nota Fiscal' : retorno+= 'Número da Nota Fiscal';
        this.form.controls['nR_BPM_NUMERO_NOTA_FISCAL'].setErrors({'required': true});
        this.form.controls['nR_BPM_NUMERO_NOTA_FISCAL'].markAsTouched();
      }
      if(this.form.controls['cD_CDU_MATRICULA_USUARIO_CAUTELA'].value == null) {
        retorno != '' ? retorno+= ', Matricula do Usuário' : retorno+= 'Matricula do Usuário';
        this.form.controls['cD_CDU_MATRICULA_USUARIO_CAUTELA'].setErrors({'required': true});
        this.form.controls['cD_CDU_MATRICULA_USUARIO_CAUTELA'].markAsTouched();
      }

      //Swal.fire('Alerta', 'Olá digite os campos corretamente nos campos: ' + retorno, 'warning');
      return;
    }
    this.form
      .get('nR_BPM_IMOBILIZADO_TI')
      ?.setValue(Number(this.form.controls['nR_BPM_IMOBILIZADO_TI'].value));
    this.form
      .get('cD_CDU_MATRICULA_USUARIO_CAUTELA')
      ?.setValue(
        Number(this.form.controls['cD_CDU_MATRICULA_USUARIO_CAUTELA'].value)
      );
    this.form
      .get('vL_BPM_VALOR_AQUISICAO')
      ?.setValue(Number(this.form.controls['vL_BPM_VALOR_AQUISICAO'].value));
    // this.form.get('vL_BPM_DEPRECIACAO_BEM')?.setValue(
    //   Number(this.form.controls['vL_BPM_DEPRECIACAO_BEM'].value));

    // this.form.get('dT_BPM_DATA_ATUALIZACAO')?.setValue(formatDate(new Date(), 'yyyy/MM/dd', 'en'));

    // this.form.value.dT_BPM_DATA_ATUALIZACAO = moment().format('DD/MM/YYYY');
    this.form.get('arquivos')?.setValue(localStorage.getItem('arquivos'));

    var cadastro: CadastroBem = this.form.value;
    cadastro.fL_BPM_ATIVO = Number(this.form.controls['fL_BPM_ATIVO'].value);
    this.datePipe.transform(cadastro.dT_BPM_DATA_NOTA_FISCAL, 'yyyy-MM-dd');
    //console.log/cadastro.dT_BPM_DATA_NOTA_FISCAL);
    // cadastro.nR_BPM_BEM_PATRIMONIAL = 0
    this.loading = true;
    //console.log/cadastro);

    if (this.form.invalid) {
      Swal.fire('Alerta', 'Olá digite os campos corretamente', 'warning');
      this.activeModal.close();
      return;
    } else if (this.nR_BPM_BEM_PATRIMONIAL == 0) {
      this.cadastroBemService.insert(cadastro).subscribe(
        (data) => {
          if (localStorage.getItem('arquivos')) {
            this.uploadService
              .update(
                data,
                JSON.parse(JSON.stringify(localStorage.getItem('arquivos')))
              )
              .subscribe(
                (data) => {
                  //console.log/'Sucesso:  ', JSON.stringify(data));
                },
                (err) => {
                  //console.log/'Erro:  ', JSON.stringify(err));
                }
              );
          }
          Swal.fire(
            'Adicionado!',
            data + ' Bem adicionado com sucesso!',
            'success'
          ).then(() => {
            localStorage.removeItem('arquivos');
            this.loading = false;
            this.activeModal.close();
            this.router.navigateByUrl('/cadastrarBem');
          });
        },
        (err) => {
          this.loading = false;
        }
      );
    } else {
      this.cadastroBemService
        .update(this.nR_BPM_BEM_PATRIMONIAL, cadastro)
        .subscribe(
          (data) => {
            if (localStorage.getItem('arquivos')) {
              this.uploadService
                .update(
                  this.nR_BPM_BEM_PATRIMONIAL,
                  JSON.parse(JSON.stringify(localStorage.getItem('arquivos')))
                )
                .subscribe(
                  (data) => {
                    //console.log/'Sucesso:  ', JSON.stringify(data));
                  },
                  (err) => {
                    //console.log/'Erro:  ', JSON.stringify(err));
                  }
                );
            }
            Swal.fire(
              'Atualizado!',
              this.nR_BPM_BEM_PATRIMONIAL + ' Bem atualizada com sucesso!',
              'success'
            ).then(() => {
              localStorage.removeItem('arquivos');
              this.loading = true;
              this.activeModal.close();
              //this.router.navigateByUrl('/cadastrarBem');
            });
          },
          (err) => {
            this.loading = false;
          }
        );
    }
  }
}
